import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Formik } from "formik";
import { extractNodes } from "../../extractors";
import { NotFoundError } from "../../api";
import { SubmitButton, ObjectsTypeahead } from "../Form";
import { ObjectsType } from "../../constants";
import { accessRightsShape, intlShape } from "../../shapes";
import { sortBy } from "../../utils";
import {
  withApi,
  apiShape,
  withNotifier,
  notifierShape,
  withRules,
  rulesShape,
} from "../../context";
import List from "../List/List";
import NodeItem from "../Nodes/NodeItem";
import Hint from "../Hint";

type Props = {
  api: apiShape;
  accessRights?: accessRightsShape;
  intl: intlShape;
  rules?: rulesShape;
  object?: {
    id?: number;
    itemType?: "asset" | "instrumentation";
  };
  notifier: notifierShape;
};

export function NodesAssignList(props: Props) {
  const { intl, api, notifier, accessRights, rules, object } = props;

  const objectTypePlural = `${object?.itemType}s`;
  const objectId = object?.id;

  const [nodes, setNodes] = React.useState();

  const parentInstrumentation = objectTypePlural.includes("instrumentations")
    ? { id: objectId }
    : null;
  const parentAsset = objectTypePlural.includes("assets")
    ? { id: objectId }
    : null;

  React.useEffect(() => {
    const loadData = async () => {
      try {
        const responseNodes = await api.get(
          `/${objectTypePlural}/${objectId}/nodes`,
          { include: "parent,type,type.parent,worst_asset_status" },
        );
        const loadedNodes = sortBy(extractNodes(responseNodes), "name");
        setNodes(loadedNodes);
      } catch (error) {
        if (!(error instanceof NotFoundError)) {
          notifier.showError(api.translateError(error));
        }
      }
    };
    if (object) {
      loadData();
    }
  }, [objectId]);

  const handleOnNodeRemoved = (node: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    setNodes(nodes.filter((n: $TSFixMe) => n.id !== node.id));
  };

  const assignNode = async (values: $TSFixMe, { resetForm }: $TSFixMe) => {
    const payload = { nodes: [{ id: values.node.id }] };
    try {
      await api.post(`/${objectTypePlural}/${objectId}/nodes`, payload);
      // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
      setNodes(sortBy(nodes.concat([{ ...values.node }]), "name"));
      notifier.showSuccess(
        intl.formatMessage({
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          id: rules.node(values.node).get("assignNotificationKey"),
        }),
      );
    } catch (error) {
      if (!(error instanceof NotFoundError)) {
        notifier.showError(api.translateError(error));
      }
    }
    resetForm({ values: {} });
  };

  const renderNodeAssignForm = (formProps: $TSFixMe) => {
    const { handleSubmit, isSubmitting, values } = formProps;
    return (
      <form onSubmit={handleSubmit} noValidate>
        <ObjectsTypeahead
          {...formProps}
          id="node-typeahead"
          name="node"
          label={intl.formatMessage({ id: "node.actions.assign" })}
          placeholder={intl.formatMessage({ id: "label.name" })}
          objectsToIgnore={nodes}
          objectsType={ObjectsType.Nodes}
        />
        <div className="btn-group">
          <SubmitButton
            id="assign-node-button"
            disabled={!values.node}
            fetching={isSubmitting}
            text={intl.formatMessage({ id: "button.assign" })}
          />
        </div>
      </form>
    );
  };

  return objectId && nodes ? (
    <div id="node-list">
      <h2>
        <FormattedMessage id="nodes_list.header" />
      </h2>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {accessRights.canPermit ? (
        <Formik
          initialValues={{}}
          id="assign-node-formik"
          onSubmit={assignNode}
        >
          {renderNodeAssignForm}
        </Formik>
      ) : null}
      {(nodes as $TSFixMe).length > 0 ? (
        <List id="nodes_assign_list">
          {(nodes as $TSFixMe).map((node: $TSFixMe) => (
            <NodeItem
              key={node.id}
              // @ts-expect-error TS(2322) FIXME: Type '{ key: any; node: any; parentNode: any; pare... Remove this comment to see the full error message
              node={node}
              parentNode={node}
              parentInstrumentation={parentInstrumentation}
              parentAsset={parentAsset}
              onNodeRemoved={handleOnNodeRemoved}
              showItemMenu
              fromDetailsPage
              assignedObjectAccessRights={accessRights}
            />
          ))}
        </List>
      ) : (
        <Hint
          id="hint-no-nodes-assigned"
          details={intl.formatMessage({ id: "node_list.no_nodes_assign" })}
        />
      )}
    </div>
  ) : null;
}
// @ts-expect-error TS(2345) FIXME: Argument of type '(props: Props) => Element | null... Remove this comment to see the full error message
export default injectIntl(withNotifier(withApi(withRules(NodesAssignList))));
